import * as React from "react";
import PropTypes from "prop-types";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { tokens } from "../../theme/tokens";

export function CircularProgressWithLabel(props) {
  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      {/* Background Track - Makes it look more premium */}
      <CircularProgress
        variant="determinate"
        sx={{
          color: tokens.color.border.default,
        }}
        size={props.size || 40}
        thickness={4}
        value={100}
      />
      {/* Active Progress */}
      <CircularProgress
        variant="determinate"
        {...props}
        sx={{
          color: tokens.color.brand.primaryAction,
          position: "absolute",
          left: 0,
          // Smooth out the progress movement
          transition: "stroke-dashoffset 0.3s ease-in-out",
          [`& .MuiCircularProgress-circle`]: {
            strokeLinecap: "round", // Rounded edges look friendlier
          },
        }}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          variant="caption"
          component="div"
          sx={{
            fontSize: "0.65rem",
            fontWeight: 700,
            color: tokens.color.text.primary,
          }}
        >
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}

CircularProgressWithLabel.propTypes = {
  value: PropTypes.number.isRequired,
  size: PropTypes.number,
};
